import upperFirst from 'lodash.upperfirst';
import flatten from 'lodash.flatten';
import { isObject, processDataSummaryValue } from '../../../helpers';
import getLinkToPublishedContent from './get-link-to-published-content';
import getPropValue from './get-prop-value';
import getLinkBasedOnValue from './get-link-based-on-value';
const buildPropsToDisplayWithContent = (props, propsToDisplay = []) => {
  if (!isObject(propsToDisplay[0])) {
    return propsToDisplay.map(key => {
      if (!key) return null;
      const propValue = getPropValue(key, props);
      if (!propValue) return null;
      const propName = key.split('.').join(' ');
      return [upperFirst(propName), propValue, '', ''];
    }).filter(Boolean);
  }
  return flatten(propsToDisplay.map(options => {
    const {
      propertiesToDisplay,
      label,
      modifier = '',
      enableLink
    } = options;
    return propertiesToDisplay.map(key => {
      if (!key) return null;
      const objPropValue = getPropValue(key, props, options);
      if (!objPropValue) return null;
      const processedValue = processDataSummaryValue(objPropValue, options);
      const link = getLink(enableLink, key, props, processedValue);
      return [upperFirst(label), processedValue, link, modifier];
    });
  })).filter(Boolean);
};
export default buildPropsToDisplayWithContent;
function getLink(enableLink, key, props, objPropValue) {
  let link = '';
  if (enableLink) {
    link = getLinkToPublishedContent(key, props);
    if (!link) {
      link = getLinkBasedOnValue(objPropValue);
    }
  }
  return link;
}
//# sourceMappingURL=build-props-to-display-with-content.js.map